<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

<div
  class="harness"
  (click)="$event.stopPropagation();"
  (keydown)="$event.key === 'Escape' || $event.stopPropagation();"
  tabindex="-1">
  <div class="between"><ng-container *ngTemplateOutlet="contentTemplate" /></div>
</div>

<bowstring--sheet #localeSheetComponent>
  @defer {<bowstring--header>
    <h6 i18n>Select your locale.</h6>
  </bowstring--header>
  <bowstring--divider />
  <bowstring--section>
    @for (_projectLocaleId of projectLocaleIds; track $index) {<bowstring--button
      [disabled]="projectLocaleIds[$index] === projectLocaleId"
      level="2"
      (output)="projectLocaleIds[$index] === projectLocaleId || changeLocale(projectLocaleIds[$index]);">
      <bowstring--symbol input="Globe" />
      <bowstring--label [input]="localeDisplayNames[projectLocaleIds[$index]]" />
    </bowstring--button>}
  </bowstring--section>}
</bowstring--sheet>

<ng-template #contentTemplate>
  <bowstring--main>
    @if (bannerTemplateRef$(); as bannerTemplateRef) {<ng-container *ngTemplateOutlet="bannerTemplateRef" />}
    <bowstring--flexbox-container
      alignItems="last baseline"
      flexDirection="row"
      flexWrap="wrap"
      gapColumn="calc(var(--bowstring--root--gap-column) * pow(var(--phi), -1))"
      gapRow="calc(var(--bowstring--root--gap-row) * pow(var(--phi), -1))"
      justifyContent="space-between">
      <bowstring--header fontSizeExponent="-3">
        <h1>
          <bowstring--link
            exact
            url="/">
            <bowstring--logo />
          </bowstring--link>
        </h1>
      </bowstring--header>
      @if ((projectRoutes | bowstringFindRouteByPath:'gallery') || (projectRoutes | bowstringFindRouteByPath:'shop') || (projectRoutes | bowstringFindRouteByPath:'account') || projectRoutes.slice(1 + (configLib.gallery.enabled ? 1 : 0) + (configLib.shop.enabled ? 1 : 0)).slice(0, -3 + (configLib.account.enabled ? -1 : 0)).length) {<bowstring--nav>
        @if (projectRoutes | bowstringFindRouteByPath:'gallery'; as route) {<bowstring--link [url]="'/' + route.path">
          <bowstring--label [input]="route.data?.['title']" />
        </bowstring--link>}
        @if (projectRoutes | bowstringFindRouteByPath:'shop'; as route) {<bowstring--link [url]="'/' + route.path">
          <bowstring--label [input]="route.data?.['title']" />
        </bowstring--link>}
        @for (route of projectRoutes.slice(1 + (configLib.gallery.enabled ? 1 : 0) + (configLib.shop.enabled ? 1 : 0)).slice(0, -3 - (configLib.account.enabled ? 1 : 0)); track $index) {<bowstring--link [url]="'/' + route.path">
          <bowstring--label [input]="route.data?.['title']" />
        </bowstring--link>}
        @if (projectRoutes | bowstringFindRouteByPath:'account'; as route) {<bowstring--link [url]="'/' + route.path">
          <bowstring--label [input]="route.data?.['title']" />
        </bowstring--link>}
      </bowstring--nav>}
    </bowstring--flexbox-container>
    <router-outlet />
    @if (aboveTemplateRef$(); as aboveTemplateRef) {<bowstring--above>
      <ng-container *ngTemplateOutlet="aboveTemplateRef" />
    </bowstring--above>}
  </bowstring--main>
  @defer {@if (belowTemplateRef$(); as belowTemplateRef) {<bowstring--below>
    <ng-container *ngTemplateOutlet="belowTemplateRef" />
  </bowstring--below>}}
  <bowstring--footer>
    <bowstring--header>
      <h6>
        <bowstring--link
          exact
          url="/">
          <bowstring--logo />
        </bowstring--link>
      </h6>
    </bowstring--header>
    <bowstring--section
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="space-between">
      <bowstring--flexbox-container flexDirection="row">
        @if ((projectRoutes | bowstringFindRouteByPath:'gallery') || (projectRoutes | bowstringFindRouteByPath:'shop') || projectRoutes.slice(1 + (configLib.gallery.enabled ? 1 : 0) + (configLib.shop.enabled ? 1 : 0)).slice(0, -3 - (configLib.account.enabled ? 1 : 0)).length) {<bowstring--flexbox-container alignItems="flex-start">
          @if (projectRoutes | bowstringFindRouteByPath:'gallery'; as route) {<bowstring--link [url]="'/' + route.path">
            <bowstring--label [input]="route.data?.['title']" />
          </bowstring--link>}
          @if (projectRoutes | bowstringFindRouteByPath:'shop'; as route) {<bowstring--link [url]="'/' + route.path">
            <bowstring--label [input]="route.data?.['title']" />
          </bowstring--link>}
          @for (route of projectRoutes.slice(1 + (configLib.gallery.enabled ? 1 : 0) + (configLib.shop.enabled ? 1 : 0)).slice(0, -3 - (configLib.account.enabled ? 1 : 0)); track $index) {<bowstring--link [url]="'/' + route.path">
            <bowstring--label [input]="route.data?.['title']" />
          </bowstring--link>}
        </bowstring--flexbox-container>}
        @if (configLib.account.enabled) {@if (!authenticationService.user$() || authenticationService.user$()?.isAnonymous) {<bowstring--flexbox-container alignItems="flex-start">
          <bowstring--link
            [disabled]="signinSheetComponent.openModelWithTransform$()"
            (output)="signinSheetComponent.openModel$.set(true);">
            <bowstring--label
              i18n-input
              input="Sign in" />
          </bowstring--link>
          <bowstring--link
            [disabled]="signupSheetComponent.openModelWithTransform$()"
            (output)="signupSheetComponent.openModel$.set(true);">
            <bowstring--label
              i18n-input
              input="Create your account" />
          </bowstring--link>
        </bowstring--flexbox-container>} @else {<bowstring--flexbox-container alignItems="flex-start">
          @if (projectRoutes | bowstringFindRouteByPath:'account'; as route) {<bowstring--link [url]="'/' + route.path">
            <bowstring--label [input]="route.data?.['title']" />
          </bowstring--link>}
          <bowstring--link
            [disabled]="signoutSheetComponent.openModelWithTransform$()"
            (output)="signoutSheetComponent.openModel$.set(true);">
            <bowstring--label
              i18n-input
              input="Sign out" />
          </bowstring--link>
        </bowstring--flexbox-container>}

        <bowstring--sheet #signinSheetComponent>
          @defer {<bowstring--header>
            <h6 i18n="@@libs--Components--Signin--Header">Sign in.</h6>
          </bowstring--header>
          <bowstring--signin [sheetComponent]="signinSheetComponent" />}
        </bowstring--sheet>
        <bowstring--sheet #signoutSheetComponent>
          @defer {<bowstring--header>
            <h6 i18n="@@libs--Components--Signout--Header">Sign out?</h6>
          </bowstring--header>
          <bowstring--signout [sheetComponent]="signoutSheetComponent" />}
        </bowstring--sheet>
        <bowstring--sheet #signupSheetComponent>
          @defer {<bowstring--header>
            <h6 i18n="@@libs--Components--Signup--Header">Create your account.</h6>
          </bowstring--header>
          <bowstring--signup [sheetComponent]="signupSheetComponent" />}
        </bowstring--sheet>}
        <bowstring--flexbox-container alignItems="flex-start">
          @if (projectRoutes | bowstringFindRouteByPath:'privacy'; as route) {<bowstring--link [url]="'/' + route.path">
            <bowstring--label [input]="route.data?.['title']" />
          </bowstring--link>}
          @if (projectRoutes | bowstringFindRouteByPath:'terms'; as route) {<bowstring--link [url]="'/' + route.path">
            <bowstring--label [input]="route.data?.['title']" />
          </bowstring--link>}
        </bowstring--flexbox-container>
      </bowstring--flexbox-container>
      <bowstring--flexbox-container flexDirection="row">
        <bowstring--flexbox-container alignItems="flex-start">
          <bowstring--link>
            <bowstring--symbol input="ArrowUpForwardAppFill" />
            <bowstring--label input="Instagram" />
          </bowstring--link>
        </bowstring--flexbox-container>
      </bowstring--flexbox-container>
    </bowstring--section>
    <bowstring--divider />
    <bowstring--section id="connectivitySection"
      flexDirection="row"
      flexWrap="wrap">
      <div [hidden]="connectivityService.connected$()">
        <bowstring--link
          disabled>
          <bowstring--symbol input="NetworkSlash" />
          <bowstring--label
            i18n-input
            input="Disconnected" />
        </bowstring--link>
      </div>
      <div [hidden]="!connectivityService.connected$()">
        <bowstring--link
          disabled>
          <bowstring--symbol input="Network" />
          <bowstring--label
            i18n-input
            input="Connected" />
        </bowstring--link>
      </div>
    </bowstring--section>
    <bowstring--section id="informationAndOptionsSection"
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="center">
      <bowstring--flexbox-container
        flexDirection="row"
        flexGrow="1"
        flexWrap="wrap">
        <span style="white-space: nowrap;">&copy;&nbsp;<div id="copyrightYear">2025&nbsp;</div><bowstring--link
          inline
          [url]="brandLib.copyrightHolderUrl">
          <bowstring--label [input]="brandLib.copyrightHolder" />
        </bowstring--link></span>
        <span style="white-space: nowrap;">{{ packageVersion }}&dash;{{ projectName }}&nbsp;&lpar;<bowstring--link
          inline
          [url]="'https://github.com/gavinsawyer/bowstring/commit/' + gitInfoPartial.hash">
          <bowstring--label [input]="gitInfoPartial.hash || ''" />
        </bowstring--link>&rpar;</span>
      </bowstring--flexbox-container>
      <bowstring--flexbox-container
        flexDirection="row"
        justifyContent="center">
        <bowstring--link
          [disabled]="localeSheetComponent.openModelWithTransform$()"
          (output)="localeSheetComponent.openModel$.set(true);">
          <bowstring--symbol input="Globe" />
          <bowstring--label [input]="localeDisplayNames[projectLocaleId]" />
        </bowstring--link>
        @if (configLib.shop.enabled) {<bowstring--link
          [disabled]="currencySheetComponent.openModelWithTransform$()"
          (output)="currencySheetComponent.openModel$.set(true);">
          <bowstring--symbol [input]="currencies[exchangeService.userCurrency$()].symbolName" />
          <bowstring--label [input]="exchangeService.userCurrency$()" />
        </bowstring--link>

        <bowstring--sheet #currencySheetComponent>
          @defer {<bowstring--heading-group>
            <bowstring--header>
              <h6 i18n>Select your currency.</h6>
            </bowstring--header>
            <p i18n>View prices with a live exchange rate from {{ configLib.shop.currency }}&nbsp;&lpar;{{ currencies[configLib.shop.currency].name }}&rpar;.</p>
          </bowstring--heading-group>
          <bowstring--divider />
          <bowstring--section>
            @for (currency of currencyKeys; track $index) {<bowstring--button
              [disabled]="currency === exchangeService.userCurrency$()"
              level="2"
              (output)="exchangeService.userCurrency$.set(currency); currencySheetComponent.openModel$.set(false);">
              <bowstring--symbol [input]="currencies[currency].symbolName" />
              <bowstring--label [input]="currency + ' (' + currencies[currency].name + ')'" />
            </bowstring--button>}
          </bowstring--section>}
        </bowstring--sheet>}
      </bowstring--flexbox-container>
    </bowstring--section>
  </bowstring--footer>
  @if (errorsService.errors$(); as errors) {<bowstring--errors-container>
    @for (error of errors; track $index) {<bowstring--error
      level="2"
      open>{{ error }}</bowstring--error>}
  </bowstring--errors-container>}
</ng-template>
